import React, { useState, useEffect } from 'react'
import { DatePicker } from 'antd'
import numeral from 'numeral'
import _ from 'lodash'
import moment from 'moment'
import { Query } from 'react-apollo'
import { Loading, Div, P } from 'konsys-ui'
import { Bar } from 'react-chartjs-2'
import { Container } from './styled'
import { GET_REVENUE } from '../../constants/graphql/query'

const Center = ({ children }) => (
  <Div flexDirection='column' display='flex' justifyContent='center' alignItems='center' width='100%' margin='20px 0 0 0'>{children}</Div>
)
export default () => {
  const [date, setDate] = useState(moment())
  const [isopen, setIsopen] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => { window.removeEventListener('resize', handleResize) }
  }, [])

  return (
    <Container>
      <Center>
        <Query
          query={GET_REVENUE}
          variables={{
            date,
          }}
        >{({ data, loading, error }) => {
          if (loading && _.isUndefined(data.RevenueYearlyReport)) return <Loading />
          if (error) return <P>Error</P>
          const mappedData = {
            datasets: [{
              label: 'รายได้',
              data: data.RevenueYearlyReport.map(v => v.revenue),
              backgroundColor: '#DAD870',
              borderWidth: 0,
              hoverBackgroundColor: '#DAD870bb',
            }, {
              label: 'ค่าใช้จ่าย',
              data: data.RevenueYearlyReport.map(v => v.expense),
              backgroundColor: '#FF5C4D',
              borderWidth: 0,
              hoverBackgroundColor: '#FF5C4Dbb',
            }, {
              label: 'กำไร/ขาดทุน',
              data: data.RevenueYearlyReport.map(v => v.diff),
              backgroundColor: '#FFCD58',
              borderWidth: 0,
              hoverBackgroundColor: '#FFCD58bb',
            }],
            labels: ['ตุลาคม', 'พฤศจิกายน', 'ธันวาคม', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน'],
          }
          return (
            <Div style={{ background: '#fff' }} padding='40px' width='100%' display='flex' flexDirection='column'>
              <Div alignSelf='flex-end' display='flex' margin='0 0 16px 0' width='100%' justifyContent='flex-end'>
                { loading && <Loading size='small' style={{ marginRight: 16 }} /> }
                <DatePicker
                    value={date}
                    open={isopen}
                    allowClear={false}
                    mode="year"
                    placeholder='เลือกเดือน'
                    format="YYYY"
                    onOpenChange={status => setIsopen(status)}
                    onPanelChange={(value) => {
                      setDate(value)
                      setIsopen(false)
                    }}
                    // onChange={() => setDate(null)}
                />
              </Div>
              <Bar
                style={{ margin: 'auto' }}
                data={mappedData}
                // redraw={lastWidth !== width}
                height={400}
                options={{
                  maintainAspectRatio: false,
                  scales: {
                    yAxes: [{
                      ticks: {
                        callback(value) {
                          return numeral(value).format('0,0.00')
                        },
                      },
                    }],
                  },
                  tooltips: {
                    callbacks: {
                      label(tooltipItem, chart) {
                        const datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || ''
                        return `${datasetLabel}: ${numeral(tooltipItem.yLabel).format('0,0.00')} บาท`
                      },
                    },
                  },
                }}
              />
            </Div>
          )
        }}
        </Query>
      </Center>
    </Container>
  )
}
